import React, { useEffect } from 'react';
import { mediaUrl } from '../utils/media';
import { DONATE_URL } from '../utils/donate';

const carouselImages = [
  'IMG-20260622-WA0009.jpg',
  'Photo from Anand Mashatte(24).jpg',
  'Photo from Anand Mashatte(22).jpg',
  'Photo from Anand Mashatte(41).jpg',
  'Photo from Anand Mashatte(43).jpg',
  'DSC06370.JPG',
  'Photo from Anand Mashatte(47).jpg',
  'Photo from Anand Mashatte(29).jpg',
  'IMG-20260629-WA0003.jpg',
];

const HeroCarousel: React.FC = () => {
  useEffect(() => {
    // Initialize Bootstrap carousel
    const carouselElement = document.querySelector('#header-carousel');
    if (carouselElement && window.bootstrap) {
      new window.bootstrap.Carousel(carouselElement, {
        interval: 5000,
        ride: 'carousel',
      });
    }
  }, []);

  return (
    <div className="container-fluid p-0 mb-5">
      <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {carouselImages.map((file, index) => (
            <div className={`carousel-item${index === 0 ? ' active' : ''}`} key={file}>
              <img
                className="w-100"
                src={`${mediaUrl(file)}?tr=w-2000,q-90`}
                alt="2026 Pen and Notebooks Drive at a local school"
              />
              <div className="carousel-caption">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-7 pt-5">
                      <h1 className="display-4 text-white mb-3 animated slideInDown">
                        2026 Pen &amp; Notebooks Drive
                      </h1>
                      <p className="fs-5 text-white-50 mb-5 animated slideInDown">
                        Supporting students across Bidar with essential learning supplies. Your generosity helps children start the school year ready to learn.
                      </p>
                      <a
                        className="btn btn-primary py-2 px-3 animated slideInDown"
                        href={DONATE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Donate Now
                        <div className="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2">
                          <i className="fa fa-arrow-right"></i>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default HeroCarousel;

